import { EndorsementPremiumChange } from '@domain/schemas/endorsement-premium-change';
import type { EndorsementData } from '@domain/types/entity';

import type { EndorsementFormState } from '../types';

import { getValuesFromEndorsement } from './get-values-from-endorsement';

export function getInitialValues(entity?: EndorsementData, isEdit = false): Partial<EndorsementFormState> {
  if (isEdit && entity) {
    return {
      ...getValuesFromEndorsement(entity),
      endorsement_summary_template_id: entity.endorsement_summary_template_id ?? 1,
    };
  }

  // For new endorsements, expiry date will be set by useEffect in controller
  return {
    premium_change: EndorsementPremiumChange.NONE,
  };
}
